import { Role } from '../../../../shared/helpers/permissions';
import { ParticipantState } from '../../types';

export const getParticipantRole = (participant?: ParticipantState) => {
    if (participant?.isOwner) {
        return Role.OWNER;
    }

    if (participant?.isModerator) {
        return Role.ADMIN;
    }

    return Role.MEMBER;
};
